import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import lightbox from 'alpine-tailwind-lightbox';
import themeSwitcher from './alpinejs_modules/theme_switcher.js';

Alpine.plugin(focus);
Alpine.plugin(lightbox);
Alpine.data('themeSwitcher', themeSwitcher);

export default Alpine